import styled from '@emotion/styled';
import { motion } from 'framer-motion';

export const ContentArea = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow: auto;
  touch-action: pan-x pan-y;
`;

/*
 * 핀치/더블 탭 프리뷰 transform 전용 래퍼.
 * framer-motion(MotionPageBox)이 inline transform을 소유하므로,
 * 제스처 프리뷰는 반드시 이 일반 div에 걸어야 리렌더 시 지워지지 않는다.
 */
export const PinchLayer = styled.div`
  position: relative;
  display: flex;
  flex-shrink: 0;
  margin: auto;
`;

export const MotionPageBox = styled(motion.div)`
  position: relative;
  flex-shrink: 0;
`;

export const PreloadBox = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  visibility: hidden;
  pointer-events: none;
`;
